module.exports = __webpack_public_path__ + "static/media/shape-2.4781ab9a.svg";